<mat-drawer-container id="app-main-container" [ngClass]="{ 'service-down-notifier-container': (!isMobileView && hasServiceDownWarns), 'mobile-version': isMobileView}">
    <mat-drawer-content>
        <div class="fixed-top">
            <app-header></app-header>

            <ng-container *ngIf="!isMobileView && hasServiceDownWarns">
                <app-service-down-warn></app-service-down-warn>
            </ng-container>

        </div>
        <div class="main">
            <div class="d-flex flex-column flex-shrink-0 sidenav">
                <app-sidebar [sideNavData]="sideNavData"></app-sidebar>
            </div>
            <div class="d-flex flex-column align-items-stretch flex-shrink dash-main">                
                <ng-container *ngIf="!screenStatus; else reqStatus">
                    <router-outlet></router-outlet>
                </ng-container>

                <ng-template #reqStatus>
                    <div class="center-child">
                        <bh-status [state]="screenStatus" [message]="statusMessage"></bh-status>
                    </div>
                </ng-template>
            </div>
        </div>
        <div class="mat-drawer-transition" *ngIf="sidePanel">
            <div class="mat-drawer-backdrop mat-drawer-shown custom-backdrop"></div>
        </div>
        <app-users-selector></app-users-selector>
    </mat-drawer-content>

</mat-drawer-container>